import React from 'react';
import styled from 'styled-components';
import withPageEntry from '../../withPageEntry';
import {useOutlet} from 'reconnect.js';
import * as AppActions from '../../AppActions';

function Store(props) {
  const [dimension] = useOutlet('dimension');
  const [about] = useOutlet('about');
  const bookingImgUrl = about?.booking_images?.[0]?.expected_url;

  return (
    <Wrapper rwd={dimension.rwd}>
      {/* 訂位區塊 */}
      <div className="content booking-section">
        <div className="left">
          <h2>「甜點師的料理劇場」訂位</h2>
          <div className="text">
            {AppActions.F(about, 'booking_description')}
          </div>
          <a
            className="booking-btn"
            href="https://inline.app/booking/seasonartisanpatissier/season"
            target="_blank"
            rel="noreferrer">
            inline 訂位
          </a>
        </div>
        <div style={{width: 20, height: 20}} />
        <div className="right">
          {bookingImgUrl && <img src={bookingImgUrl} alt="booking" />}
        </div>
      </div>

      {/* 門市介紹區塊 */}
      <div className="content store-section">
        <div className="left">
          <h2>{AppActions.L('store_intro')}</h2>
          <div className="text">{AppActions.F(about, 'store_description')}</div>
        </div>
        <div style={{width: 20, height: 20}} />
        <div className="right">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.960775520049!2d121.54752257543032!3d25.03540517781548!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442abce7474ee7f%3A0xa602be16a8b3bcde!2zU0VBU09OIEFydGlzYW4gUMOidGlzc2llcuaVpuWNl-aXl-iJpuW6lw!5e0!3m2!1szh-TW!2stw!4v1730195765449!5m2!1szh-TW!2stw"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: var(--topNavBarHeight);
  min-height: 100vh;
  padding: ${(props) =>
    props.rwd === 'mobile'
      ? `calc(var(--topNavBarHeight) + 22px) 20px 40px 20px`
      : `calc(var(--topNavBarHeight) + 140px) 50px 40px 50px`};

  & > .content {
    margin: 0 auto;
    max-width: var(--contentMaxWidth);
    width: 100%;
    display: ${(props) => (props.rwd === 'mobile' ? 'block' : 'flex')};

    & > .left {
      flex: 3;
    }
    & > .right {
      flex: 2;
      display: flex;
      justify-content: flex-end;
      padding-top: ${(props) => (props.rwd === 'mobile' ? '0px' : '40px')};

      & > iframe,
      & > img {
        max-width: 300px;
        width: 100%;
        height: 300px;
        border: solid 1px var(--table-border-color);
        object-fit: cover;
      }
    }

    & h2 {
      border-bottom: solid 1px var(--table-border-color);
      font-weight: 300;
      color: var(--text-4-color);
      padding-bottom: 12px;
      margin-bottom: 12px;
    }

    & .text {
      white-space: pre-line;
      line-height: 2;
      font-weight: 300;
      color: var(--text-4-color);
    }

    & .booking-btn {
      display: inline-block;
      margin-top: 20px;
      padding: 10px 24px;
      background-color: var(--primaryColor);
      color: #ffffff;
      text-decoration: none;
      font-weight: 300;
      font-size: 14px;
      border: 1px solid var(--primaryColor);
      transition: all 0.3s ease;
      cursor: pointer;
      text-align: center;

      &:hover {
        background-color: #ffffff;
        color: var(--primaryColor);
      }
    }
  }

  & > .booking-section {
    margin-bottom: ${(props) => (props.rwd === 'mobile' ? '40px' : '80px')};
  }
`;

export default withPageEntry(Store);
